import { Task, ExpectedTaskAnswerMetadata } from "@jelly/lesson";

const items = [
  { id: "ce3fdb9a-39b4-4bdf-9064-c09441344868", content: "Tonality vs Time</br>(Aures/Terhardt)", options: {} },
];

const groups = [
  {
    id: "e89a85ed-043e-4413-b319-b9d35a7fa90c",
    content: "does not operate with psychoacoustic parameters",
    options: {},
  },
  { id: "ca747335-30eb-40ea-9386-a7c1568c9bc4", content: "ignores cavum cochae resonance of the ear", options: {} },
  { id: "6a756bfc-b061-4e72-9be1-844eb7b86adf", content: "incompletely implemented", options: {} },
  { id: "0406f332-baf6-48f2-97b4-1939fd5739d1", content: "does not give spectral information", options: {} },
  { id: "3898b8a7-f8af-4190-b232-f8a1372a563f", content: "can only be used for pure tone analysis", options: {} },
  { id: "fcf858a8-3260-4031-8e2a-701430cac4d2", content: "require high frequency resolution", options: {} },
];

export const task: Task = {
  id: "51888697-2f3c-48c0-9d61-e008f6e02e3b",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "6a756bfc-b061-4e72-9be1-844eb7b86adf", itemsId: ["ce3fdb9a-39b4-4bdf-9064-c09441344868"] },
    { groupId: "0406f332-baf6-48f2-97b4-1939fd5739d1", itemsId: ["ce3fdb9a-39b4-4bdf-9064-c09441344868"] },
  ],
};
